import addComponentLoader, { importWithRetry } from '@/utils/component-loader'
import { defineAsyncComponent } from 'vue'

const componentMapping =  {
  newEventForm: defineAsyncComponent(() => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "new-event-form" */ './form')))
}

addComponentLoader(componentMapping, {}, () => importWithRetry(() => import(/* webpackMode: "lazy" */ /* webpackChunkName: "new-event-form-store-getter" */ './store')))
